<template>
    <div>
        <button
            type="button"
            class="btn text-sm is-danger"
            @click="$modal.show('deactivate-technical-service')"
        >
            Inaktivera
        </button>
        <adaptive-form-modal
            name="deactivate-technical-service"
            :primary-button-text="buttonText"
            primary-button-class="is-danger"
            title="Inaktivera teknisk tjänst"
            :redirect-to="redirectRoute"
            method="patch"
            :action="actionRoute"
        >
            Vill du verkligen inaktivera {{ technicalService.name }}?
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            technicalService: {
                type: Object,
                required: true,
            },
        },

        computed: {
            buttonText() {
                return `Inaktivera ${this.technicalService.name}`;
            },
            actionRoute() {
                return route('api.technical-services.deactivate', this.technicalService);
            },
            redirectRoute() {
                return route('admin.technical-services.index');
            },
        },
    };
</script>
